import { createAction } from '@reduxjs/toolkit';

export const SOCKET_LISTENERS_TYPE = 'saga/socketListeners';
export const socketListenersAction = createAction(SOCKET_LISTENERS_TYPE);
